import { render } from "./TransformationSegmentEditor.vue?vue&type=template&id=5c0f2fdc"
import script from "./TransformationSegmentEditor.vue?vue&type=script&lang=js"
export * from "./TransformationSegmentEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/transformation/TransformationSegmentEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c0f2fdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c0f2fdc', __exports__)) {
    api.reload('5c0f2fdc', __exports__)
  }
  
  module.hot.accept("./TransformationSegmentEditor.vue?vue&type=template&id=5c0f2fdc", () => {
    api.rerender('5c0f2fdc', render)
  })

}


export default __exports__